export const formatBytes = (bytes: number) => {
  if (!bytes || bytes <= 0 || !Number.isFinite(bytes)) {
    return '0 B'
  }

  const units = ['B', 'KB', 'MB', 'GB', 'TB']
  const index = Math.floor(Math.log(bytes) / Math.log(1024))
  const clampedIndex = Math.min(Math.max(0, index), units.length - 1)
  const value = bytes / 1024 ** clampedIndex

  return `${value.toFixed(2)} ${units[clampedIndex]}`
}
